/* eslint-disable */
import { MAX_PREPAYMENTS } from '@/js/common/Constants/globalParams';

import TourProductObjectValue from '../ObjectValue/TourProduct';
import TourFactory from './Tour';

let TourProductFactory = function (data, resorts) {
	var tourProduct = {},
		element;


	element = data['tourCriteria'];
	if (typeof element != "undefined") {
		tourProduct['tourCriteria'] = element;
	}

	element = data?.tour?.id || null;
	if (typeof element !== 'undefined') {
		tourProduct['id'] = element;
	}

	element = data['hash'];
	if (typeof element != "undefined") {
		tourProduct['hash'] = element;
	}

	element = data['price'];
	if (typeof element != "undefined") {
		tourProduct['price'] = element;
	}

	element = data['discount'];
	if (typeof element != "undefined") {
		tourProduct['discount'] = element;
	}

	element = data['finalPrice'];
	if (typeof element != "undefined") {
		tourProduct['finalPrice'] = element;
	}

	element = data['firstPayment'];
	if (typeof element != "undefined") {
		tourProduct['firstPayment'] = element;
	} else {
		tourProduct['firstPayment'] = 1;
	}

	element = data['additionalTerms'];
	if (typeof element != "undefined") {
		tourProduct['additionalTerms'] = element;
	}

	element = data['medicalInsurance'];
	if (typeof element != "undefined") {
		tourProduct['medicalInsurance'] = element;
	}

	element = data['produceVisaByMerchant'];
	if (typeof element != "undefined") {
		tourProduct['produceVisaByMerchant'] = element;
	}

	element = data['availableTransfers'];
	if (typeof element != "undefined") {
		tourProduct['availableTransfers'] = element;
	}

	element = data['tour'];
	if (typeof element != "undefined") {
		tourProduct['tour'] = new TourFactory(data['tour'], resorts);
	}

	element = data['transferType'];
	if (typeof element != "undefined") {
		tourProduct['transferType'] = element;
	}

	element = data['type'];
	if (typeof element != "undefined") {
		tourProduct['type'] = element;
	}

	element = data.firstPaymentDefinitions;
	if (typeof element !== 'undefined') {
		tourProduct.firstPaymentDefinitions = element?.slice(0, MAX_PREPAYMENTS);
	}

    element = data.firstPaymentDefinition;
    if (typeof element !== 'undefined') {
        tourProduct.firstPaymentDefinition = element;
    }

    element = data.allFirstPaymentDefinitions;
    if (typeof element !== 'undefined') {
        tourProduct.allFirstPaymentDefinitions = element?.slice(0, MAX_PREPAYMENTS);
    }

	return new TourProductObjectValue(tourProduct);
};

export default TourProductFactory;
